import React, { useMemo } from "react";
import { AudioTrack } from "providers/AudioProvider/types";
import { unplayableVoicings } from "providers/AudioProvider/cueTiming";
import { formatCueTime } from "providers/AudioProvider/editorErrors";
import { useUiLang } from "utils/uiLanguage";

const SHOWN = 5;

/**
 * Сколько озвучек плеер пропустит и где они: файл есть, а длины нет. Расписание
 * (useVoicingSchedule) выбирает только реплики с положительной длиной — такая озвучка
 * скачивается и молчит. Раньше об этом не говорило ничего.
 */
export const UnplayableVoicings = ({ tracks }: { tracks: AudioTrack[] }) => {
    const en = useUiLang() === "en";
    const skipped = useMemo(() => unplayableVoicings(tracks), [tracks]);
    if (!skipped.length) return null;
    const where = skipped.slice(0, SHOWN).map((track) => formatCueTime(track.start)).join(", ");
    const more = skipped.length > SHOWN ? "…" : "";
    return (
        <div
            data-unplayable-voicings={skipped.length}
            style={{
                padding: "4px 12px",
                backgroundColor: "#fff2f0",
                borderBottom: "1px solid #ffccc7",
                color: "#cf1322",
                fontSize: 12,
            }}
            title={
                en
                    ? "The player skips a voicing whose length is not positive. Voice it again (♪) — the synthesis recomputes the length; if the «⚠ time» mark on the left offers «restore window», restore it first."
                    : "Плеер пропускает озвучку, у которой длина не больше нуля. Переозвучьте её (♪) — синтез пересчитает длину; если метка «⚠ время» слева предлагает «вернуть окно» — сначала верните окно."
            }
        >
            {en
                ? `⚠ ${skipped.length} voicing(s) will not play — broken time: ${where}${more}`
                : `⚠ Не проиграется озвучек: ${skipped.length} — испорчено время: ${where}${more}`}
        </div>
    );
};
